angular.module("app").controller("TopMatchesPageController", [
    '$scope',
    'preloadedData',
    'topMatchesService',
    'pagination',
    '$uibModal',
    '$timeout',
    'logger',
    'errorHandler',
    function ($scope, preloadedData, topMatchesService, pagination, $modal, $timeout, logger, errorHandler) {
        var pendingListRequest;
        preloadedData = preloadedData || {};
        $scope.filterOptions = {
            type: 'all'
        };

        $scope.tooltip = {
            newMatch: "",
            editMatch: ""
        };
        $scope.newMatch = {};
        $scope.matches = angular.copy(preloadedData.items);
        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, preloadedData.total_count);

        $scope.makeNewMatch = function () {
            if (!$scope.newMatch.type) {
                $scope.newMatch.type = 'prematch';
                $scope.newMatch.game_id = undefined;
            }
        };

        $scope.getClone = function (match) {
            return angular.copy(match)
        };

        $scope.createMatch = function () {
            var requestData = {
                topMatch: angular.copy($scope.newMatch)
            };
            topMatchesService.create(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.matchCreatedSuccessfully");
                        $scope.updateList({
                            current_page: 1,
                            limit: $scope.pagination.limit
                        });
                        delete $scope.newMatch.type;
                        delete $scope.newMatch.game_id
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.closeCreateForm = function () {
            delete $scope.newMatch.type;
            delete $scope.newMatch.game_id
        };

        $scope.deleteMatch = function (match) {
            var requestData = {
                id: match.id
            };

            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmDeleteAction.html",
                controller: "ConfirmDeleteActionModalController"
            });

            modalInstance.result.then(function () {
                topMatchesService.deleteMatchById(requestData).then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.updateList();
                            logger.logSuccess("global.matchDeleteSuccessfully");
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            })
        };

        $scope.updateList = function (externalOptions) {
            var requestObject = {
                type: $scope.filterOptions.type == 'all' ? undefined : $scope.filterOptions.type,
                limit: $scope.pagination.limit
            };
            if (!!externalOptions) {
                angular.extend(requestObject, externalOptions)
            }

            topMatchesService.getList(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.matches = angular.copy(response.items);
                        $scope.pagination.totalItems = response.total_count
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.changeMatch = function (clone, index) {
            var requestData = {
                topMatch: angular.copy(clone)
            };

            delete requestData.topMatch.editing;

            topMatchesService.change(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        delete clone.editing;
                        logger.logSuccess("global.matchUpdateSuccessfully");
                        $scope.matches[index] = clone;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }
    }
]);